import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const CLUId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      placeholder="Enter CLU ID"
      type="text"
      name="cluID"
      label="CLU ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default CLUId;
